export default {
    bindings: {
        guest: '=',
        staff: '<',
        appendToBody: '<',
        canDisable: '<'
    },
    controller: 'staffPickerController',
    template: require('../views/staffPicker.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/components/staffPicker.component.js